import { useTranslation } from 'react-i18next'
import { useField, useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../../../../constants/common'
import { Field } from '../../../../../Field'
import {
  getIsListingReadOnly,
  LISTING_FORM_FIELD_NAME_PHOTOS,
} from '../../../../../RentalPortalListing'
import { RentalPortalPhotoGallery } from '../../../../RentalPortalPhotoGallery'

function PhotosField({
  isLoading,
  listing,
  listingId,
  onDeletePhoto,
  onUploadingFilesChange,
}) {
  const { t } = useTranslation()

  const { setFieldValue } = useFormikContext()

  const [field] = useField(LISTING_FORM_FIELD_NAME_PHOTOS)

  function handleChange(nextPhotos) {
    setFieldValue(LISTING_FORM_FIELD_NAME_PHOTOS, nextPhotos)
  }

  const isReadOnly = getIsListingReadOnly(listing)

  return (
    <Field
      shouldAdaptToMobileScreen
      isLoading={isLoading}
      label={`${t('RentalPortal.ListingFormPhotosLabelKey')}:`}
    >
      <RentalPortalPhotoGallery
        disabled={isReadOnly}
        disabledReason={
          isReadOnly
            ? t('RentalPortal.ListingEditNotAllowedTooltipKey')
            : undefined
        }
        photos={field.value || EMPTY_LIST}
        onChange={handleChange}
        onDeletePhoto={listingId ? onDeletePhoto : undefined}
        onUploadingFilesChange={onUploadingFilesChange}
      />
    </Field>
  )
}

export default PhotosField
